import { atom } from 'recoil';

export const petFloatingActiveState = atom<boolean>({
  key: 'petFloatingActiveState',
  default: false,
});

export const petActivePetIDState = atom<string>({
  key: 'petActivePetIDState',
  default: '',
}); 